// src/components/Router.jsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/Propos';
import Projets from '../pages/Projets';
import Bibliotheque from '../pages/Bibliotheque';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import Portfolio from '../pages/projects/portfolio';
import PGM from '../pages/projects/PGM';
import Binzegger from '../pages/projects/BInzegger';
import Aidadom from '../pages/projects/Aidadom';
import SAE501 from '../pages/projects/SAE501';
import Cheerleading from '../pages/projects/Cheerleading';
import Motiondesign from '../pages/projects/MotionDesign';
import Communication from '../pages/projects/Communication';

import ScrollToTop from './ScrollToTop';


const AppRouter = () => {
  return (
    <Router>
      <Header />
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/mon-parcours" element={<About />} />
          <Route path="/realisations" element={<Projets />} />


          <Route path="/bibliotheque" element={<Bibliotheque />} />
          


          <Route path="/realisations/portfolio-developpement-portfolio" element={<Portfolio />} />
          <Route path="/realisations/PGM-refonte-site-WordPress-thème-custom" element={<PGM />} />
          <Route path="/realisations/Binzegger-refonte-site-WordPress-Astra-Elementor" element={<Binzegger />} />
          <Route path="/realisations/Aidadom-refonte-site-WordPress-Elementor" element={<Aidadom />} />
          <Route path="/realisations/Conception-table-jeux-interactive" element={<SAE501 />} />
          <Route path="/realisations/goldenstarscheerleading-développement-site-WordPress-projet-universitaire-groupe" element={<Cheerleading />} />
          <Route path="/realisations/realisation-motion-design" element={<Motiondesign />} />
          <Route path="/realisations/creation-supports-de-communication" element={<Communication />} />

        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default AppRouter;